import { useTranslate, HttpError } from '@refinedev/core';
import { Create, useForm } from '@refinedev/antd';
import { Form, Input, Select } from 'antd';
import type {
  OrganizationOut,
  OrganizationCreateIn,
} from '@/api/generated/schemas';
import { OrganizationStatus } from '@/api/generated/schemas';

export const OrganizationCreate = () => {
  const t = useTranslate();
  const { formProps, saveButtonProps } = useForm<
    OrganizationOut,
    HttpError,
    OrganizationCreateIn
  >({
    resource: 'tenancy.organizations',
  });

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          name="name"
          label={t('tenancy.organizations.fields.name')}
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="status"
          label={t('tenancy.organizations.fields.status')}
          initialValue={OrganizationStatus.pending}
        >
          <Select
            options={Object.values(OrganizationStatus).map((value) => ({
              label: t(`tenancy.organizations.status.${value}`),
              value,
            }))}
          />
        </Form.Item>
      </Form>
    </Create>
  );
};
